import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import qs from 'qs';
import { MERCHANT_ORDER_TYPE } from "../helper/constants/constants.js";

export async function getMerchants({ searchQuery, limit, page, sortBy, isPartner }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/merchants/listmerchant?searchQuery=${searchQuery || ""}&limit=${limit ||
        ""}&page=${page || ""}&sortBy=${sortBy || ""}&isPartner=${isPartner || ""}`
    });


    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getMerchantsOrder({ limit, page, sortBy }) {
  try {
    const queryParams = qs.stringify({
      merchantId: null,
      name: '',
      jdCategoryId: '',
      skuId: '',
      brand: null,
      limit: 20,
      page: 1,
      status: 'NEW ORDER, ORDER SENT',
      isDeleted: false,
      isOwnPOP: 88
    })
    let response = await axios.Get({
      url: `${adminUrl}/merchants/transactions?${queryParams}`
    });


    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getMerchantDetail(merchantId) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/merchants/${merchantId}`
    });


    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function createMerchant({
  merchantName,
  merchantId,
  phoneNumber,
  password,
  description,
  SIUP,
  picName,
  picPhoneNumber,
  isActive,
  jdCategory,
  localSeller,
  localStore,
  region,
  isPartner,
  APIStatus, clientId, clientSecret, limitedIP, allowCreateOrder
}, categoryList) {
  try {

    // let jdCategory = categoryList;

    let response = await axios.Post({
      url: `${adminUrl}/merchants/addnewmerchant`,
      data: { merchantName, merchantId, phoneNumber, password, description, SIUP, picName, picPhoneNumber, isActive, localSeller, jdCategory, localStore, region, APIStatus, clientId, clientSecret, isPartner, limitedIP, allowCreateOrder }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function toogleMerchantStatus(adminId) {
  try {
    let response = await axios.Patch({
      url: `${adminUrl}/merchants/${adminId}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function updateMerchant({
  _id,
  merchantName,
  phoneNumber,
  password,
  confirmPassword,
  description,
  SIUP,
  picName,
  picPhoneNumber,
  isActive,
  region,
  jdCategory,
  localSeller,
  localStore,
  isPartner,
  APIStatus, clientId, clientSecret, limitedIP, allowCreateOrder
}, categoryList) {
  try {

    // let jdCategory = categoryList

    let response = await axios.Put({
      url: `${adminUrl}/merchants/id/${_id}`,
      data: {
        merchantName,
        phoneNumber,
        password,
        confirmPassword,
        description,
        SIUP,
        picName,
        picPhoneNumber,
        isActive,
        region,
        jdCategory,
        localStore,
        localSeller,
        isPartner,
        APIStatus, clientId, clientSecret, limitedIP, allowCreateOrder
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function productLogs(productId) {
  try {

    let response = await axios.Get({
      url: `${adminUrl}/merchants/productlogs/${productId}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getParentCategory(id) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/product-parentcategories/${id}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getMerchantListShipping() {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/merchants/getlistshipping`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getMerchantProducts({
  limit,
  page,
  name,
  jdCategoryId,
  productStatus,
  isDeleted,
  isOwnPOP,
  merchantId,
  brand,
  installmentPriceValue,
  installmentPriceStart,
  installmentPriceEnd,
  datequeryType,
  startDate,
  endDate,
  sortid,
  sort,
  skuId,
  localProduct,
  merchantProductRequest = false
}) {
  try {
    const queryParams = qs.stringify({
      limit,
      page,
      name,
      jdCategoryId,
      productStatus,
      isDeleted,
      isOwnPOP,
      merchantId,
      brand,
      installmentPriceValue,
      installmentPriceStart,
      installmentPriceEnd,
      datequeryType,
      startDate,
      endDate,
      sortid,
      sort,
      skuId,
      localProduct,
      merchantProductRequest
    });
    let response = await axios.Get({
      url: `${adminUrl}/merchants/getallproducts?${queryParams}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}


export async function approveMerchantProductRequest({ productId, discount }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/merchants/approveproduct`,
      data: { productId, discount }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function rejectMerchantProductRequest({ productId, discount }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/merchants/rejectproduct`,
      data: { productId, discount }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getMerchantTransaction({
  merchantId,
  order,
  shippingId,
  status,
  region,
  createdDateVariable,
  dateStart,
  dateEnd,
  settlementStartDateVariable,
  settlementStartDate,
  settlementEndDate,
  rejectedStartDateVariable,
  rejectedStartDate,
  rejectedEndDate,
  page,
  sort,
  limit
}) {
  try {
    const queryParams = qs.stringify({
      merchantId: merchantId ? merchantId.value : '',
      order,
      shippingId,
      status: status ? status.value : '',
      region: region,
      createddatevariable: createdDateVariable ? createdDateVariable.value : '',
      datestart: dateStart,
      dateend: dateEnd,
      settlementstartdatevariable: settlementStartDateVariable ? settlementStartDateVariable.value : '',
      settlementstartdate: settlementStartDate,
      settlementenddate: settlementEndDate,
      rejectedstartdatevariable: rejectedStartDateVariable ? rejectedStartDateVariable.value : '',
      rejectedstartdate: rejectedStartDate,
      rejectedenddate: rejectedEndDate,
      page,
      sort,
      limit,
      province: '',
    });
    let response = await axios.Get({
      url: `${adminUrl}/merchants/transactions?${queryParams}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

// approve bast
export async function merchantApproveBAST({ orderId, merchantId }) {
  try {
    let queryParams = qs.stringify({
      merchantId,
      status: MERCHANT_ORDER_TYPE.ACCEPTED_ORDER,
    })
    let response = await axios.Post({
      url: `${adminUrl}/merchants/approvebast?${queryParams}`,
      data: { orderId }
    });

    if (response.statusCode !== 200) {
      return { error: response };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
// reject bast
export async function merchantRejectBAST({ orderId, merchantId }) {
  try {
    let queryParams = qs.stringify({
      merchantId,
      status: MERCHANT_ORDER_TYPE.REJECTED_ORDER,
    })
    let response = await axios.Post({
      url: `${adminUrl}/merchants/rejectbast?${queryParams}`,
      data: { orderId }
    });

    if (response.statusCode !== 200) {
      return { error: response };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
// reject order
export async function merchantRejectOrder({ merchantId }) {
  try {
    let queryParams = qs.stringify({
      merchantId,
      status: MERCHANT_ORDER_TYPE.REJECTED_ORDER,
    });
    let response = await axios.Get({
      url: `${adminUrl}/merchants/updatetransaction?${queryParams}`
    });

    if (response.statusCode !== 200) {
      return { error: response };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
// approve settle
export async function merchantApproveSettlement({ orderId, merchantId, settlementPrice, settlementDate }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/merchants/approvesettlement`,
      data: { orderId, merchantId, settlementPrice, settlementDate }
    });

    if (response.statusCode !== 200) {
      return { error: response };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}